import I18n from 'lib/i18n'
import React from 'react'
import { useActions, useValues } from 'kea'
import PropTypes from 'prop-types'

import Checkbox from 'lib/forms/checkbox-svg'

import sceneLogic from '~/scenes/search/logic'
import naturalCompare from 'string-natural-compare'
import filtersLogic from '~/scenes/search/filters-page/logic'

export default function CategoryTags ({ fullScreenFiltersPage }) {
  const { unsavedFilter } = useValues(filtersLogic)
  const { updateUnsavedFilter } = useActions(filtersLogic)
  const { results } = useValues(sceneLogic)

  // all possible tags
  const categoryTags = results.category_tags

  // selected tags
  const selectedTags = {}
  unsavedFilter.category_tags.split(',').forEach(id => {
    selectedTags[parseInt(id).toString()] = true
  })

  const sortedTags = []

  categoryTags
    .filter(tag => tag.is_master)
    .forEach(tag => {
      sortedTags.push(tag)
      categoryTags
        .filter(t => t.master_id === tag.id)
        .sort((a, b) => naturalCompare.caseInsensitive(a.title, b.title))
        .forEach(t => sortedTags.push(t))
    })

  categoryTags
    .filter(t => !t.is_master && !t.master_id)
    .sort((a, b) => naturalCompare.caseInsensitive(a.title, b.title))
    .forEach(t => sortedTags.push(t))

  function toggleTag (tagId) {
    // get array with tag added or removed
    let tags = Object.keys(selectedTags)
    if (tags.includes(tagId.toString())) {
      tags = tags.filter(v => v !== tagId.toString())
    } else {
      tags.push(tagId.toString())
    }

    // if we hide the main category tag, remove the subcategory tags for it
    const allTags = {}
    categoryTags.forEach(tag => {
      allTags[tag.id] = tag
    })

    const newSelectedTags = {}
    tags.forEach(id => {
      newSelectedTags[id] = true
    })

    tags = tags
      .map(id => allTags[id])
      .filter(tag => tag && (tag.is_master || !tag.master_id || newSelectedTags[tag.master_id]))
      .map(tag => tag.id)

    updateUnsavedFilter({
      category_tags: tags.join(',')
    })
  }

  const filteredTags = sortedTags
    // show subtags only if master is selected
    .filter(tag => tag.is_master || !tag.master_id || selectedTags[tag.master_id])

  return (
    <div className='filter-section'>
      <div className='filter-title'>{I18n.t('react.search.all_filters.options')}</div>
      <div
        className='checkbox-list'
        style={{
          maxHeight: fullScreenFiltersPage ? 'unset' : 'calc(100vh - 300px)'
        }}
      >
        {filteredTags.map(tag => (
          <Checkbox key={tag.id} checked={!!selectedTags[tag.id]} onChange={() => toggleTag(tag.id)}>
            {tag.title}
          </Checkbox>
        ))}
      </div>
    </div>
  )
}

CategoryTags.propTypes = {
  fullScreenFiltersPage: PropTypes.bool
}
